module.exports = __webpack_public_path__ + "img/avatar-big.3d3a6240.png";